import { CheckmarkCircle } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { languageToPhraseKeyMap } from 'modules/shared-menu/constants';

import { LanguageStats } from '../types';

type Props = {
  className?: string;
  leftLanguage: Language | null;
  primaryLanguage: Language;
  rightLanguage: Language | null;
  statsByLanguage: Map<Language, LanguageStats>;
};

const Root = styled.div`
  ${typographyCss.Body3}
  display: flex;
  color: ${cbSemanticCssVars.textPrimary};
`;

const Icon = styled(CheckmarkCircle)`
  fill: ${colors.wolt100};
  width: 24px;
  margin-inline-end: 16px;
`;

const VerifyTranslationNotice = ({
  className,
  leftLanguage,
  primaryLanguage,
  rightLanguage,
  statsByLanguage,
}: Props) => {
  const intl = useIntl();
  const leftLanguageStats = leftLanguage && statsByLanguage.get(leftLanguage);
  const rightLanguageStats = rightLanguage && statsByLanguage.get(rightLanguage);

  if (
    (!leftLanguageStats || leftLanguageStats.unverified === 0) &&
    (!rightLanguageStats || rightLanguageStats.unverified === 0)
  ) {
    return null;
  }

  return (
    <Root className={className}>
      <Icon />
      <FormattedMessage
        id="translation.verifyTranslationsNotice"
        values={{ lang: intl.formatMessage({ id: languageToPhraseKeyMap[primaryLanguage] }) }}
      />
    </Root>
  );
};

export default VerifyTranslationNotice;
